import {Pageable, PageModel} from "@/api/Paging.ts";
import {http} from "@/api/HttpClient.ts";
import {Scene} from "@/scenes/Scene.ts";

export interface SceneFilter {
    campaignId: string;
    name?: string;
}

interface SaveSceneRequest {
    id: string;
    name: string;
    campaignId: string;
    imageId: string;
}

export async function searchScenes(pageable: Pageable, filter: SceneFilter, signal?: AbortSignal): Promise<PageModel<Scene>> {
    const response = await http.get<PageModel<Scene>>("/scenes", {params: {...pageable, ...filter}, signal});
    return response.data;
}

export async function getScene(id: string, signal?: AbortSignal): Promise<Scene> {
    const response = await http.get<Scene>(`/scenes/${encodeURIComponent(id)}`, {signal});
    return response.data;
}

export async function saveScene(scene: Scene): Promise<Scene> {
    const request: SaveSceneRequest = {
        id: scene.id,
        name: scene.name,
        campaignId: scene.campaignId,
        imageId: scene.image.id,
    };
    const response = await http.post<Scene>("/scenes", request);
    return response.data;
}

export async function deleteScene(id: string): Promise<void> {
    await http.delete(`/scenes/${encodeURIComponent(id)}`);
}
